import PhotoCameraOutlinedIcon from '@mui/icons-material/PhotoCameraOutlined';
import { Avatar, AvatarProps, IconButton } from '@mui/material';
import classnames from 'classnames';
import UploadAction, { useUploadActionStyles } from './Site/UploadAction';

type AvatarUploadProps = {
  proccessFile: (file: File) => void;
  imageUrl?: string;
  avatarProps?: AvatarProps;
};

const AvatarUpload = ({ imageUrl, avatarProps, proccessFile }: AvatarUploadProps) => {
  const { classes } = useUploadActionStyles();

  const handleFileChange = (files: FileList | null) => {
    if (files) {
      proccessFile(files[0]);
    }
  };
  return (
    <UploadAction proccessFiles={handleFileChange}>
      <Avatar src={imageUrl} {...avatarProps} />
      <IconButton className={classnames(classes.centeredElement, classes.hoverAction)} size="large">
        <PhotoCameraOutlinedIcon />
      </IconButton>
    </UploadAction>
  );
};

export default AvatarUpload;
